export enum PlanningBoardQueries {
  View = 'view',
  Order = 'order',
  FromDate = 'from',
  ToDate = 'to',
  Page = 'page',
  Size = 'size',
}
